export default [{
  question: 'What is peer on peer abuse now called?',
  answers: [{
    label: 'Pupil on pupil',
    isAnswer: false,
  },
  {
    label: 'Child on child',
    isAnswer: true,
  },
  {
    label: 'Bullying',
    isAnswer: false,
  },]
},
{
  question: 'How many examples of child on child abuse does KCSIE give?',
  answers: [{
    label: '8',
    isAnswer: false,
  },
  {
    label: '9',
    isAnswer: true,
  },
  {
    label: '10',
    isAnswer: false,
  },]
},
{
  question: 'Staff working directly with children should read at LEAST…',
  answers: [{
    label: 'Part 1 of Guidance',
    isAnswer: true,
  },
  {
    label: 'Part 1 and 2 of Guidance',
    isAnswer: false,
  },
  {
    label: 'All of Guidance',
    isAnswer: false,
  },]
},
{
  question: 'Safeguarding is the responsbility of…',
  answers: [{
    label: 'Headteacher',
    isAnswer: false,
  },
  {
    label: 'Designated Safeguarding Lead (DSL)',
    isAnswer: false,
  },
  {
    label: 'Everyone',
    isAnswer: true,
  },]
},
{
  question: 'What would you do if you had a serious concern about a child and the safeguarding leads or head were not in the school?',
  answers: [{
    label: 'Wait until the next day',
    isAnswer: false,
  },
  {
    label: 'Speak to parents',
    isAnswer: false,
  },
  {
    label: 'Contact MASH or LCSS for advice',
    isAnswer: true,
  },]
},
{
  question: 'What do the initials CCE mean?',
  answers: [{
    label: 'Child Criminal Exploitation',
    isAnswer: true,
  },
  {
    label: 'Child Centred Exploitation',
    isAnswer: false,
  },
  {
    label: 'Child Concern Exploitation',
    isAnswer: false,
  },]
},
{
  question: 'How is neglect defined?',
  answers: [{
    label: 'The persistent failure to meet a child’s basic physical and/or psychological needs, likely to result in the serious impairment of the child’s health or development.',
    isAnswer: true,
  },
  {
    label: 'Failure to meet a child’s basic physical and/or psychological needs, likely to result in the serious impairment of the child’s health or development.',
    isAnswer: false,
  },
  {
    label: 'The persistent failure to meet a child’s psychological needs, likely to result in the serious impairment of the child’s health or development.',
    isAnswer: false,
  },]
}]